import React, { memo } from 'react';

interface EmailActionsProps {
  selectedCount: number;
  onAddToEmail: (field: 'to' | 'cc' | 'bcc') => void;
}

const EmailActions = memo<EmailActionsProps>(({ selectedCount, onAddToEmail }) => {
  return (
    <div className="flex">
      <div className="flex flex-col sm:flex-row sm:items-center gap-2 min-w-0">
        <span className="text-sm text-gray-600 whitespace-nowrap">
          {selectedCount} selected
        </span>
        <div className="flex gap-1 min-w-0">
          <button
            onClick={() => onAddToEmail('to')}
            disabled={selectedCount === 0}
            className={`px-2 py-1 text-xs rounded transition-colors whitespace-nowrap flex-shrink-0 ${
              selectedCount > 0
                ? 'bg-blue-500 text-white hover:bg-blue-600 hover:shadow-md'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            Add to To
          </button>
          <button
            onClick={() => onAddToEmail('cc')}
            disabled={selectedCount === 0}
            className={`px-2 py-1 text-xs rounded transition-colors whitespace-nowrap flex-shrink-0 ${
              selectedCount > 0
                ? 'bg-blue-500 text-white hover:bg-blue-600 hover:shadow-md'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            Add to Cc
          </button>
          <button
            onClick={() => onAddToEmail('bcc')}
            disabled={selectedCount === 0}
            className={`px-2 py-1 text-xs rounded transition-colors whitespace-nowrap flex-shrink-0 ${
              selectedCount > 0
                ? 'bg-blue-500 text-white hover:bg-blue-600 hover:shadow-md'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            Add to Bcc
          </button>
        </div>
      </div>
    </div>
  );
});

EmailActions.displayName = 'EmailActions';

export default EmailActions;
